<template>
  <div>
    <h2>Account Actions</h2>
    <div class="action-group">
      <span>Any change in mind, or lorem ipsum dolor sit amet?</span>
      <button
        type="button"
        class="freeze"
      >
        Freeze Account
      </button>
    </div>
    <div class="action-group">
      <span>Not enjoying or not happy with the Djuli experience?</span>
      <button
        type="button"
        class="delete"
      >
        Delete Account
      </button>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
h2 {
  font-family: Inter;
  font-weight: 600;
  font-size: 19px;
  color: #0f172a;
  padding-bottom: 10px;
}
.action-group {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
.action-group > span {
  font-family: Inter;
  font-size: 14px;
  color: #64748b;
  width: 380px;
  padding-right: 30px;
}
button {
  border: none;
  width: 114px;
  height: 34px;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.freeze {
  background: #6a60ce;
  color: #f8fafc;
}
.delete {
  background: #ef4444;
  color: #f8fafc;
}
</style>
